import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'
import axiosExportApi from '@/plugins/axiosExport'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getLeads = (params) => axios.get(`${getWorkspaceId()}/leads/paginated`, { params })
const getDetailLead = (slug) => axios.get(`${getWorkspaceId()}/leads/${slug}`)
const deleteLeads = (data) => axios.delete(`${getWorkspaceId()}/leads`, { data })

const getLeadsFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/leads/filters-and-sorting`)

const exportLeadsCSVData = ({ params, onDownloadProgress }) => axiosExportApi.get(`export/${getWorkspaceId()}/leads/csv`, { params, responseType: 'blob', onDownloadProgress })

const generateLeadsXLSXData = (formData) => axiosExportApi.post(`export/${getWorkspaceId()}/leads/xlsx`, formData)
const getLeadsXLSXStatuses = () => axiosExportApi.get(`export/${getWorkspaceId()}/leads/xlsx`)
const downloadLeadsXLSXData = (slug) => axiosExportApi.get(`export/${getWorkspaceId()}/leads/xlsx/${slug}`, { responseType: 'blob' })

export {
    getLeads,
    getDetailLead,
    deleteLeads,
    getLeadsFiltersAndSorting,
    exportLeadsCSVData,
    generateLeadsXLSXData,
    getLeadsXLSXStatuses,
    downloadLeadsXLSXData,
}
